import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import HomepageMemberHighlightDesktopLayout from './HomepageMemberHighlightDesktopLayout';
import HomepageMemberHighlightMobileLayout from './HomepageMemberHighlightMobileLayout';
import { generateBasicBreakpointObject } from 'connect-dot-com-ui-components/utils/layout';

function Gradient({
  children
}) {
  return /*#__PURE__*/_jsx(CUIBox, {
    as: "span",
    display: "block",
    bgGradient: "linear(to-l, #CE4EAA, #F56271)",
    bgClip: "text",
    lineHeight: "52px",
    children: children
  });
}

export default function HomepageMemberHighlight() {
  return /*#__PURE__*/_jsxs(CUIBox, {
    children: [/*#__PURE__*/_jsx(CUIHeading, {
      size: "xl",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.homepage.memberHighlight.heading_jsx",
        elements: {
          Gradient
        }
      })
    }), /*#__PURE__*/_jsx(CUIText, {
      textAlign: "center",
      maxW: "600px",
      marginTop: 4,
      marginBottom: generateBasicBreakpointObject(4, 12),
      mx: "auto",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.memberHighlight.subheading"
      })
    }), /*#__PURE__*/_jsx(HomepageMemberHighlightDesktopLayout, {
      display: {
        base: 'none',
        md: 'flex'
      }
    }), /*#__PURE__*/_jsx(HomepageMemberHighlightMobileLayout, {
      display: {
        base: 'grid',
        md: 'none'
      }
    })]
  });
}